export var shadows = {
    raised: "0 0.1rem 0.2rem rgba(0, 0, 0, 0.1), 0 0 0.2rem rgba(0, 0, 0, 0.2)",
    raisedInset: "0 0.1rem 0.2rem rgba(0, 0, 0, 0.1) inset, 0 0 0.2rem rgba(0, 0, 0, 0.2) inset",
    sticky: "0 0.2rem 0.4rem rgba(0, 0, 0, 0.1), 0 0 0.1rem rgba(0, 0, 0, 0.2)",
    stickyInset: "0 0.2rem 0.4rem rgba(0, 0, 0, 0.1) inset, 0 0 0.1rem rgba(0, 0, 0, 0.2) inset",
    overlay: "0 0.4rem 0.8rem rgba(0, 0, 0, 0.1), 0 0 0.1rem rgba(0, 0, 0, 0.2)",
    overlayInset: "0 0.4rem 0.8rem rgba(0, 0, 0, 0.1) inset, 0 0 0.1rem rgba(0, 0, 0, 0.2) inset",
    modal: "0 1.2rem 2.4rem rgba(0, 0, 0, 0.1), 0 0 0.1rem rgba(0, 0, 0, 0.2)",
    modalInset: "0 1.2rem 2.4rem rgba(0, 0, 0, 0.1) inset, 0 0 0.1rem rgba(0, 0, 0, 0.2) inset"
};
